import React from 'react'
import '../BlockSearch/blockSearch.css'
import BlogPostArticle from '../BlockSearch/BlogPostArticle'
import BlogPostArticleSkeleton from '../BlockSearch/BlogPostArticleSkeleton'
import dd from '../FakeData/index.json'
import mainData from '../FetchDataLinks'
import SeoHelmet from '../SEOHelmet/SeoHelmet'
import UseFetch from '../UseFetch'

function Blogs() {
    let a = 0;
    let justToTest = 0;
    const timing = setTimeout(() => {
        if (!document.getElementById('blogs').classList.contains('active')) {
            document.getElementById("blogs").className += 'active';
        }
    }, 100);
    if (justToTest === 5) {
        clearTimeout(timing)
    }
    const { blogs, loading } = UseFetch(mainData.allBlogPost)
    return (
        <div className="w3l-homeblock2 py-5">
            <SeoHelmet pageName='Blogs' />
            <div className="container pt-md-4 pb-md-5">
                {/* block */}
                <h1 className="category-title mb-3"> All Blogs from {dd[0].name}</h1>
                {/* <p className="mb-md-5 mb-4 max-width">Lorem ipsum dolor sit amet elit. Id quaerat amet ipsum sunt et quos dolorum.</p> */}
                <div className="row">
                    {/* {data.map((dta) => {
                        return <BlogPostArticle PostContent={dta.PostContent} image={dta.Image} PostHead={dta.PostName} PostName={dta.PostName} authorName={dd[0].authorName} date={dta.PostedOn} time={dta.TimeToRead} />
                    })} */}
                    {!loading && blogs.map((blog) => {
                        return <BlogPostArticle key={blog.id} PostContent={blog.Content} slug={blog.slug} image={blog.Image} PostHead={blog.Headline} PostName={blog.Headline} authorName={dd[0].authorName} date={blog.date} time={blog.Time} />
                    })}
                    {loading && Array(6).fill().map(() => {
                        a++;
                        return <BlogPostArticleSkeleton key={`BlogPostSkeleton${a}`} />
                    })}
                </div>
                {/* <ul className="site-pagination text-center mt-md-5 mt-4">
                    <li><span aria-current="page" className="page-numbers current">1</span></li>
                    <li><a className="page-numbers" href="#page2">2</a></li>
                    <li><a className="page-numbers" href="#page3">3</a></li>
                    <li><span className="page-numbers dots">…</span></li>
                    <li><a className="page-numbers" href="#page7">7</a></li>
                    <li><a className="next page-numbers" href="#next">Next »</a></li>
                </ul> */}
            </div>
        </div>
    )
}

export default Blogs
